import { render } from "./P057.vue?vue&type=template&id=14483032&scoped=true"
import script from "./P057.vue?vue&type=script&lang=js"
export * from "./P057.vue?vue&type=script&lang=js"

import "./P057.vue?vue&type=style&index=0&id=14483032&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14483032"]])

export default __exports__